module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_6_m.310ee92195b2651df4eece82541defa3.png";